import React, { useLayoutEffect } from 'react';
import ReactTooltip from 'react-tooltip';
import NumberFormat from 'react-number-format';
import { Div, Text, Icon } from '@pinpoint/design-kit';
import get from 'lodash.get';

const defaultNumericFormat = {
	thousandSeparator: true,
	decimalSeparator: '.',
	thousandsGroupStyle: 'thousand',
	fixedDecimalScale: true,
	allowNegative: true,
	allowLeadingZeros: false,
	decimalScale: 0,
};

const cellFormatMap = {
	numeric: defaultNumericFormat,
	currency: {
		...defaultNumericFormat,
		decimalScale: 0,
		prefix: '$',
	},
	percentage: {
		...defaultNumericFormat,
		decimalScale: 1,
		fixedDecimalScale: false,
		suffix: '%',
	},
	percentagePoints: {
		...defaultNumericFormat,
		decimalScale: 2,
		fixedDecimalScale: false,
		suffix: ' Loss Ratio points',
	},
};

function getNegativeFormat(format, isNegative) {
	const formatting = {};
	if (isNegative) {
		switch (format) {
			case 'currency':
				formatting.suffix = ')';
				formatting.prefix = '$(';
				break;
			case 'percentage':
				formatting.suffix = ')%';
				formatting.prefix = '(';
				break;
			case 'numeric':
				formatting.suffix = ')';
				formatting.prefix = '(';
				break;
			default:
				break;
		}
	}
	return formatting;
}

/* eslint-disable react/prop-types */

function DisplayCell({ format, formattingOptions, inputValue, TextProps, DivProps, IconProps = {} }) {
	useLayoutEffect(() => {
		ReactTooltip.rebuild();
	}, [IconProps['data-tip']]);

	if (!format)
		return (
			<Div align="center" d="flex" justify="end" m="0.5px" minH="20px" rounded="sm" {...DivProps}>
				{get(IconProps, 'data-tip', false) && <Icon {...IconProps} />}
				<Text {...TextProps}>{inputValue}</Text>
			</Div>
		);
	const mergedFormat = {
		...cellFormatMap[format],
		...formattingOptions,
		// negative number formatting
		...getNegativeFormat(format, inputValue < 0),
	};
	return (
		<Div align="center" d="flex" justify="end" m="0.5px" minH="20px" rounded="sm" {...DivProps}>
			{get(IconProps, 'data-tip', false) && <Icon {...IconProps} />}
			<Text {...TextProps}>
				<NumberFormat {...mergedFormat} value={inputValue} displayType="text" />
			</Text>
		</Div>
	);
}

export default DisplayCell;
